import React from "react";

const ACN_URL = "https://acnafrica.org/";

/**
 * "Brought to you by" credit for Anti-Counterfeit Network Africa, shown on Home
 * and About.
 *
 * Always a white `--surface` band, on both pages. On About that puts it directly
 * below the RVR band, which is also a surface; the adjacent-sibling rule in the
 * theme collapses the seam between them to a single hairline rather than the two
 * that meeting borders would otherwise draw.
 */
const ParentBrand = () => (
  <section className="bl-section bl-section--surface">
    <div className="bl-shell about-parent">
      <p className="about-parent__label">Brought to you by</p>
      <a
        className="about-parent__link"
        href={ACN_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/images/ACN.png"
          alt="Anti-Counterfeit Network Africa"
          className="about-parent__logo"
          width="183"
          height="100"
          loading="lazy"
        />
      </a>
    </div>
  </section>
);

export default ParentBrand;
